import Tooltip from "../Tooltip/Tooltip";

export default function Error({ message }) {
  return message ? (
    <span className="Error">
      <Tooltip
        icon="fa-exclamation"
        style={{ marginLeft: "0" }}
        content={message}
      />
    </span>
  ) : null;
}
